module.exports = "<jf-table-view\n\t\tng-class=\"{'hide-top':!$ctrl.showTableTop}\"\n\t\toptions=\"$ctrl.tableViewOptions\"\n\t\tobject-name=\"$ctrl.objectName\">\n</jf-table-view>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-read-only-table/jf.read.only.table.view.html
// module id = 483
// module chunks = 7